export const SCREEN_SIZES = {
  XXS: 375,
  XS: 768,
  SM: 1024,
  MD: 1280,
  LG: 1600,
  XL: 1920,
  XXL: 2560
};